import http from "./index";

const $ajax = (url, data, method = "GET", obj) => {
  let params = obj ? { url, method, data, ...obj } : { url, method, data };
  return http.httpServer(params);
};

const $ajax1 = (url, data, method = "GET", obj) => {
  let params = obj ? { url, method, data, ...obj } : { url, method, data };
  return http.httpServer2(params);
};

export const Login = {
  passwordLogin: (data) => $ajax("/mobile/login", data, "POST"),
  smsLogin: (data) => $ajax("/sms/code/login", data, "POST"),
  smsCode: (data) => $ajax("/send/login/sms/code", data, "POST"),
  imageCode: (data) => $ajax("/get/active/code/base64", data),
  //imageCode: "/get/active/code",
  wechatCode: (data) => $ajax("/wechat/code", data, "POST"), // 获取微信二维码
  wechatLogin: (data) => $ajax("/check/weixin/login", data, "POST"), // 轮询微信二维码
  qqLogin: (data) => $ajax("/qq/login", data),
  weiboLogin: (data) => $ajax("/weibo/login", data),
  findPassword: (data) => $ajax("/find/password", data, "POST"), // 忘记密码，进行重置
  logout: (data) => $ajax("/login/out", data, "POST"),
  smsFindCode: (data) => $ajax("/send/find_password/sms/code", data, "POST"),
  qiyeWechat: (data) => $ajax("enterprisewechat/goback/mainhost", data, "GET"),
  qiyeWechatLogin: (data) => $ajax("enterprisewechat/login", data),
  emailLogin: (data) => $ajax("/email/login", data, "POST"),
  emailCode: (data) => $ajax("send/login/email/code", data),
  emailCodeLogin: (data) => $ajax("email/code/login", data, "POST"),
  checkVisibleRange: (data) => $ajax("/qiwei/checkVisibleRange", data, "GET"), // 校验可见范围并加入团队
};
export const postLogin = (data) => $ajax("/mobile/login", data, "POST");
export const codeLogin = (data) => $ajax("/sms/code/login", data, "POST");
export const getTeam = () => $ajax("/get/team/list");
export const changeTeam = (data) => $ajax("/change/current/team", data, "POST"); // 更新选中团队信息
export const UserInfo = (data) => $ajax("/get/personal/info", data, "POST"); // 获取用户信息
export const teamManager = (data) => $ajax("/team/manager", data); // 团队信息， 主要用于判断有木有自己的团队， 后期用于创建
export const checkTeam = (data) => $ajax("/check/current/team", data, "POST"); // 判断用户是否切换团队
export const Template = {
  directory: (data, methods) =>
    $ajax("/team/templates/directory", data, methods), // 修改文件夹名称
  templates: (data) => $ajax("/team/templates", data), // 获取列表数据
  rename: (data) => $ajax("/team/resource/rename", data, "POST"),
  collect: (data) => $ajax("/team/teamuser/collect/template", data, "POST"), // 收藏模板
  move: (data) => $ajax("/team/resource/move", data, "POST"),
  delete: (data) => $ajax("/team/resource/delete", data, "POST"), // 删除模板
  uploadPSD: (data) => $ajax("/team/home/upload", data, "POST"),
  savePSD: (data) => $ajax("/psd/save", data, "POST"), // PSD保存到数据库
  upUserInfo: (data) => $ajax("/qiwei/upUserInfo", data, "POST"), // 更新用户信息
};

export const HomeSetting = {
  uploadImg: (data) => $ajax("/team/home/uploadimg", data, "POST"),
  directory: (data) => $ajax("/get/template/directory/list", data),
  getTemplate: (data) => $ajax("/get/template/list", data), // 全部模板
  choose: (data) => $ajax("/get/template/choose/list", data), // 已选模板
  setting: (data) => $ajax("/team/home/config/setting", data, "POST"), // 保存按钮
  logoSetting: (data) => $ajax("/team/home/basic/setting", data, "POST"),
};
export const Home = {
  getData: (data) => $ajax("/get/team/home/info", data),
};

export const Brand = {
  logoUpload: (data) => $ajax("/team/resource/upload", data, "POST"),
  getData: (data) => $ajax("/team/brands", data),
  Fonts: (data, methods) => $ajax("/team/brands/fonts", data, methods), // 获取字体列表
  colors: (data, methods) => $ajax("/team/brands/colors", data, methods), // 新增 删除颜色
  fontUpload: (data) => $ajax("/team/brands/upload", data, "POST"),
  setType: (data, methods) => $ajax("/team/brands/types", data, methods),
};

export const Materials = {
  getData: (data) => $ajax("/team/materials", data),
  directory: (data, methods) =>
    $ajax("/team/materials/directory", data, methods), // 创建文件夹
  download: (data) => $ajax("/team/materials/copyright/download", data), //下载版权图片
};

export const Photo = {
  upload: "/team/copyright/upload",
  getSearchPhoto: (data) =>
    $ajax("/team/copyright/search/photo/from_url", data),
  getSearchText: (data) => $ajax("/team/copyright/search/photo", data),
  more_like: (data) => $ajax("/team/copyright/search/photo/more_like", data),
};

export const Member = {
  invitation: (data) => $ajax("/team/invitation", data), // 邀请成员
  qrcode: (data) => $ajax("/team/qrcode", data, "POST"), // 扫码邀请成员
  manager: (data) => $ajax("/team/manager", data), // 成员列表 团队信息
  add_team_member: (data) => $ajax("/add_team_member", data, "POST"), // 添加成员
  edit_team_member: (data) => $ajax("/edit_team_member", data, "POST"), // 编辑成员
  search_team_member: (data) => $ajax("/search_team_member", data, "POST"), // 搜索成员
  remove: (data, methods) => $ajax("/team/members", data, methods),
  add_excel_member: (data) => $ajax("/add_excel_member", data, "POST"), // 导入成员
  applies: (data) => $ajax("/team/applies", data), // 获取待审批人员列表
  audit: (data) => $ajax("/team/members/audit", data, "POST"), // 审批成员
  download_excel: (data) =>
    $ajax("/download_excel", data, "GET", {
      responseType: "arraybuffer",
    }),
  rename: (data) => $ajax("/team/rename", data, "POST"),
  move_founder: (data) => $ajax("/team/move/founder", data, "PATCH"),
  teamMembers: (data) => $ajax("/qiwei/teamMembers", data), // 企业微信登录 成员列表 团队信息
  qiwei_edit_team_member: (data) => $ajax("/qiwei/edit_team_member", data, "POST"), // 企业微信登录 成员列表 团队信息
};
export const Statistics = {
  statistics_use_num: (data) =>
    $ajax("/team/copyright_image/use_num", data, "POST"), // 版权图片用量数据---总量数据---日均用量返回
  statistics_use_num_details: (data) =>
    $ajax("/team/copyright_image/use_num_details", data, "POST"), // 版权图片用量详情
  statistics_use_num_details_export: (data) =>
    $ajax("/team/copyright_image/use_num_details_export", data, "GET", {
      responseType: "arraybuffer",
    }), // 版权图片用量详情导出
  statistics_use_list: (data) =>
    $ajax("/team/copyright_image/use_list", data, "POST"), // 版权图片使用数据列表
  statistics_use_details: (data) =>
    $ajax("/team/copyright_image/use_details", data, "POST"), // 版权图片使用数据详情
  statistics_use_list_export: (data) =>
    $ajax("/team/copyright_image/use_list_export", data, "GET", {
      responseType: "arraybuffer",
    }), // 版权图片使用数据详情导出

  statistics_data: (data) => $ajax("/team/member/data", data, "POST"), // 成员情况
  statistics_detail_list: (data) =>
    $ajax("/team/member/detail/list", data, "POST"), // 成员情况更多
  statistics_detail_export: (data) =>
    $ajax("/team/member/detail/export", data, "GET", {
      responseType: "arraybuffer",
    }), // 成员情况导出
  statistics_design_data: (data) =>
    $ajax("/team/member/design/data ", data, "POST"), // 成员作品数据
  statistics_design_data_list: (data) =>
    $ajax("/team/member/design/data/list ", data, "POST"), // 成员作品数据更多
  statistics_design_data_export: (data) =>
    $ajax("/team/member/design/data/export", data, "GET", {
      responseType: "arraybuffer",
    }), // 成员作品数据导出
  statistics_design_data_all: (data) =>
    $ajax("/team/member/design/data/all", data, "POST"), // 成员作品数据-全部

  statistics_enterprise_data: (data) =>
    $ajax("/team/enterprise/design/data ", data, "POST"), // 企业空间作品
  statistics_enterprise_design_detail_list: (data) =>
    $ajax("/team/enterprise/design/detail/list ", data, "POST"), // 企业空间作品更多
  statistics_enterprise_design_detail_export: (data) =>
    $ajax("/team/enterprise/design/detail/export", data, "GET", {
      responseType: "arraybuffer",
    }), // 企业空间作品导出
  statistics_enterprise_design_download_data: (data) =>
    $ajax("/team/enterprise/design/download/data", data, "POST"), // 作品下载数据
  statistics_enterprise_design_download_data_list: (data) =>
    $ajax("/team/enterprise/design/download/data/list", data, "POST"), // 作品下载数据更多
  statistics_enterprise_design_download_data_export: (data) =>
    $ajax("/team/enterprise/design/download/data/export", data, "GET", {
      responseType: "arraybuffer",
    }), // 作品下载数据导出
  statistics_enterprise_design_download_all: (data) =>
    $ajax("/team/enterprise/design/download/data/all", data, "POST"), // 作品下载数据-全部
  statistics_personal_design_data: (data) =>
    $ajax("/team/personal/design/data", data, "POST"), // 个人空间作品
  statistics_personal_design_detail_list: (data) =>
    $ajax("/team/personal/design/detail/list", data, "POST"), // 个人空间作品更多
  statistics_personal_design_download_data_export: (data) =>
    $ajax("/team/personal/design/detail/export", data, "GET", {
      responseType: "arraybuffer",
    }), // 个人空间作品导出
  // 折线图
  statistics_active: (data) => $ajax("/team/member/active", data, "POST"), // 成员活跃折线图
  statistics_active_details: (data) =>
    $ajax("/team/member/active_details", data, "POST"), // 成员活跃详情
  statistics_active_details_export: (data) =>
    $ajax("/team/member/active_details_export", data, "GET", {
      responseType: "arraybuffer",
    }), // 成员活跃详情导出
};
export const User = {
  editImage: (data) => $ajax("/edit/image", data, "POST"), // 修改用户头像
  editName: (data) => $ajax("/edit/nick_name", data, "POST"), // 修改用户名称
  editPassword: (data) => $ajax("/edit/password", data, "POST"), // 修改密码
  getMobileCode: (data) => $ajax("/send/message", data, "POST"),
  editMobile: (data) => $ajax("/edit/phone", data, "POST"), // 修改手机下一步和确认
};

export const Space = {
  directory: (data, methods) => $ajax("/team/design/directory", data, methods), // 获取、新建、重命名、删除
  myspaces: (data) => $ajax("/team/myspace", data), // 获取我的空间列表数据
  rename: (data) => $ajax("/team/teamuser/design/rename", data, "POST"), //设计重命名
  move: (data) => $ajax("/team/teamuser/design/move", data, "POST"), //移动设计
  delete: (data) => $ajax("/team/teamuser/design/delete", data, "POST"), // 删除设计
  uploadPSD: (data) => $ajax("/team/home/upload", data, "POST"),
  savePSD: (data) => $ajax("/psd/save", data, "POST"), // PSD保存到数据库
  designInfo: (data) => $ajax("/teamuser/design/info", data, "post"), //获取设计信息
};

export const Collect = {
  getData: (data, methods) =>
    $ajax("/team/teamuser/collect/list", data, methods), // 我的收藏列表
  collect: (data) => $ajax("/team/teamuser/collect/template", data, "POST"), // 收藏企业模板
  uncollect: (data) => $ajax("/team/teamuser/uncollect/template", data, "POST"), // 取消收藏企业模板
};
export const Copyright = {
  getLinkList: (data) => $ajax("/api/links", data ), // 获取底部链接
};
export const contactUs = (data) => $ajax1("/enter/team/cooperate/apply", data, "POST");

export const getCase = (data) => $ajax1("/get/case/list", data, "POST");

export const getCaseDetail = (data) => $ajax1("/get/case/info", data, "POST");

export const getFooterList = (data) => $ajax1("/get/case/recommend", data, "POST");

export const cutOutImage ={
    imageCutout : (data) => $ajax1("/image/cutout", data, "POST"),
    refineCutout: (data) => $ajax1("/image/refine_cutout", data, "POST")
}
